module.exports = __webpack_public_path__ + "img/shenhe.67489355.png";